export default __webpack_public_path__ + "media/images/error-3ab64e2b989608d9fcb79e1db6117b4e.png";